import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useEffect } from "react";
import { TinkErrorMessage } from "./components/TinkErrorMessage";
import { useTink } from "./hooks/useTink";
import { useTinkCallback } from "./hooks/useTinkCallback";

export function Tink({ onPrev }) {
  const { breakpoints } = useTheme();
  const { getIframeUrl, bankReaderWidgetUrl } = useTink();
  const { showError } = useTinkCallback(onPrev);

  useEffect(() => {
    getIframeUrl();
  }, []);

  const xs = useMediaQuery(breakpoints.down("xs"));

  if (!bankReaderWidgetUrl) return <></>;

  const frame = (bankReaderWidgetUrl) => {
    return {
      __html: `<iframe
        aria-label={'Tink bank reader widget'} 
        src=${bankReaderWidgetUrl}
        id='bank'
        name='bank'
        frameBorder='0'
        height='100%'
        width="100%"
        />`,
    };
  };

  if (showError) {
    return <TinkErrorMessage onPrev={onPrev} />;
  }

  return (
    <>
      <Box
        px={0}
        style={{
          flex: "1 1 auto",
          overflow: "hidden",
          height: 432,
          marginTop: xs ? 0 : -32,
        }}
      >
        <div
          style={{ borderRadius: "4px", overflow: "hidden", height: "100%" }}
          dangerouslySetInnerHTML={frame(bankReaderWidgetUrl)}
        />
      </Box>
    </>
  );
}
